import {FC, useContext, useState} from 'react';
import {BODY2, SUBTITLE1} from '@/utils/constants';
import {Box, SelectChangeEvent, Typography} from '@mui/material';
import Button from '@/shared/components/Button';
import Select from '@/shared/components/Select';
import {CONTACT_LIST_STEP} from '@/components/Organization/Profile/ContactList/ContactListTable/ImportContactList';
import {UpdateAttendeesFromContactListStyle} from '../UpdateAttendeesFromContactList.styles';
import {UploadAttendeeFromContactsContext} from '../UploadAttendeeFromContactsContext';

interface ISelectColumn {
	navigate: (step: number) => void;
}

const options = [
	{id: '1', name: 'First name', value: 'firstName'},
	{id: '2', name: 'Last name', value: 'lastName'},
	{id: '3', name: 'Email', value: 'email'},
	{id: '4', name: 'Phone', value: 'phoneNumber'},
	{id: '5', name: 'Meal', value: 'meals'},
	{id: '6', name: 'Address', value: 'address'},
	{id: '7', name: 'City', value: 'city'},
	{id: '8', name: 'State', value: 'state'},
	{id: '9', name: 'Zip', value: 'zip'},
];
export const SelectColumn: FC<ISelectColumn> = ({navigate}) => {
	const [value, setValue] = useState('');

	const {searchColumn, setSearchColumn} = useContext(UploadAttendeeFromContactsContext);

	const handleOptionChange = (event: SelectChangeEvent) => {
		setValue(event.target.value);
		setSearchColumn(options[Number(event.target.value) - 1].value);
	};
	return (
		<Box>
			<Box>
				<Typography variant={SUBTITLE1} sx={UpdateAttendeesFromContactListStyle.title}>
					Update existing items
				</Typography>
				<Typography variant={BODY2} sx={UpdateAttendeesFromContactListStyle.text}>
					Update items that exist in the table based on this columns:
				</Typography>
				<Select
					placeholder="Choose column"
					value={value}
					options={options}
					onChange={(event) => handleOptionChange(event)}
				/>
			</Box>
			<Box sx={UpdateAttendeesFromContactListStyle.buttonWrapper}>
				<Button onClick={() => navigate(CONTACT_LIST_STEP.VALIDATE_DATA)} title="Next" disabled={!value} />
			</Box>
		</Box>
	);
};
